import React, { ReactNode } from "react";

import { customIcon } from "./custom-icon";

const multiFrameElements = () => (
  <g transform="translate(-50 -10.25)">
    <g transform="translate(-3 3)">
      <line className="cls-1" x1="5" transform="translate(53 14)" />
      <line className="cls-1" x1="5" transform="translate(53 16)" />
      <line className="cls-1" x1="5" transform="translate(53 18)" />
      <line className="cls-1" x1="5" transform="translate(53 20)" />
      <line className="cls-1" x1="5" transform="translate(53 12)" />
    </g>
    <g transform="translate(6 3)">
      <line className="cls-1" x1="5" transform="translate(53 14)" />
      <line className="cls-1" x1="5" transform="translate(53 16)" />
      <line className="cls-1" x1="5" transform="translate(53 18)" />
      <line className="cls-1" x1="5" transform="translate(53 20)" />
      <line className="cls-1" x1="5" transform="translate(53 12)" />
    </g>
    <g transform="translate(15 3)">
      <line className="cls-1" x1="5" transform="translate(53 14)" />
      <line className="cls-1" x1="5" transform="translate(53 16)" />
      <line className="cls-1" x1="5" transform="translate(53 18)" />
      <line className="cls-1" x1="5" transform="translate(53 20)" />
      <line className="cls-1" x1="5" transform="translate(53 12)" />
    </g>
    <line className="cls-2" y2="16" transform="translate(57 11)" />
    <line className="cls-2" y2="16" transform="translate(66 11)" />
  </g>
);

const multiFrameDefs = (): ReactNode[] => [
  <style key="0">
    {`
      .cls-1, .cls-2 {
        fill: none;
        stroke: #cdcdcd;
        stroke-width: 1.5px;
      }

      .cls-2 {
        stroke-linecap: round;
      }
    `}
  </style>,
];

export const multiFrameIcon = customIcon({
  path: multiFrameElements(),
  defs: multiFrameDefs(),
  viewboxDefault: [23, 17.5],
});
